import { WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import type { MouseEvent } from 'react';

interface CaseSidebarItemWarningsProps {
  warnings: string[];
}

export function CaseSidebarItemWarnings({ warnings }: CaseSidebarItemWarningsProps) {
  if (warnings.length === 0) {
    return null;
  }

  const handleClick = (event: MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
  };

  return (
    <Tooltip
      title={
        <ul className='m-0 list-none space-y-1 p-0'>
          {warnings.map(warning => (
            <li key={warning} className='text-xs leading-4'>
              • {warning}
            </li>
          ))}
        </ul>
      }
      color='#1A1A1A'
      placement='right'
    >
      <span
        className='flex shrink-0 items-center text-[17px] text-[#BB4D00]'
        onClick={handleClick}
        onKeyDown={event => event.stopPropagation()}
      >
        <WarningOutlined />
      </span>
    </Tooltip>
  );
}
